module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/notokr-light.woff2
// module id = J01A
// module chunks = 0